import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import * as XLSX from "xlsx";
import axios from "axios";
import config from "../../config";

const ImportProductModal = ({ open, onClose, onImportSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const groupVariationsBySku = (rows) => {
    const grouped = {};
    rows.forEach((row) => {
      const key = row.sku;
      if (!grouped[key]) {
        grouped[key] = {
          ...row,
          tags: row.tags?.split(",").map((t) => t.trim()) || [],
          imageUrls: row.imageUrls?.split(",").map((url) => url.trim()) || [],
          variations: [],
        };
      }

      // Push variation
      const colorEntry = grouped[key].variations.find((v) => v.color === row.color);
      const sizeObj = {
        size: row.size,
        stock: parseInt(row.stock || 0),
        status: row.status || "active",
        price: parseFloat(row.baseprice || 0),
      };

      if (colorEntry) {
        colorEntry.sizes.push(sizeObj);
      } else {
        grouped[key].variations.push({
          color: row.color,
          sizes: [sizeObj],
        });
      }
    });
    return Object.values(grouped);
  };

  const handleImport = async () => {
    if (!file) {
      alert("❌ Vui lòng chọn file Excel!");
      return;
    }

    setLoading(true);

    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        const products = groupVariationsBySku(jsonData);

        for (const product of products) {
          const payload = {
            name: product.name,
            sku: product.sku,
            categoryId: parseInt(product.categoryId),
            BasePrice: parseFloat(product.baseprice),
            IsNew: product.isNew === true || product.isNew === "TRUE",
            ShortDescription: product.shortDescription || "",
            Description: product.description || "",
            Tags: product.tags || [],
            Variations: product.variations,
            ImageUrls: product.imageUrls, // Optional: nếu backend xử lý từ link ảnh
          };

          await axios.post(`${config.apiBaseUrl}/Products/add-from-import`, payload);
        }

        alert("✅ Import thành công!");
        onImportSuccess?.();
        onClose();
      };
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error("❌ Import lỗi:", error);
      alert("❌ Import thất bại. Kiểm tra lại định dạng file hoặc dữ liệu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          p: 3,
          width: 420,
          bgcolor: "#fff",
          borderRadius: 2,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Import Sản Phẩm từ Excel
        </Typography>
        <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Button variant="outlined" onClick={onClose}>
            Hủy
          </Button>
          <Button variant="contained" onClick={handleImport} disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : "Import"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ImportProductModal;
